<template>
	<div class="o-labels">
		<div
			v-for="label in filteredLabels"
			:key="label?.title"
			class="o-labels__label"
			:class="['o-labels--' + label?.color]"
		>
			<component :is="label?.icon" v-if="label?.icon"></component>
			<span>{{
				translations[label?.title] ? translations[label?.title] : label?.title
			}}</span>
		</div>
	</div>
</template>

<script>
//Icons
import leaf from "@web/assets/label/leaf.svg";
import sun from "@web/assets/label/sun.svg";
import heart from "@web/assets/label/heart.svg";
import star from "@web/assets/label/star.svg";

export default {
	name: "Labels",
	props: {
		labels: Object,
		newProduct: Boolean,
		inline: {
			type: Boolean,
			default: false,
		},
		saleProduct: [Object, Boolean],
	},
	computed: {
		filteredLabels() {
			//We have no labels, so return empty
			if (!this.labels) {
				return [];
			}

			if (!this.inline) {
				return this.labels;
			}

			//We are in inline mode, so return only the surisuri-picks label
			const labels = this.labels.find(
				(label) => label.handle === "surisuri-picks"
			);

			//If we hav surisuri-picks label, return it
			if (labels) {
				return [labels];
			}

			//We have no surisuri-picks label, so return the first label
			return [this.labels[0]];
		},
	},
	components: {
		//Icons
		leaf,
		sun,
		heart,
		star,
	},
};
</script>
